import { useSignal } from "@preact/signals-react"

export default function useCategoriesPopover() {
	const isOpenPopover = useSignal(null)

	const onClosePopover = () => {
		isOpenPopover.value = null
	}

	const onOpenPopover = value => {
		isOpenPopover.value = value
	}

	return {
		isOpenPopover: isOpenPopover.value,
		onClosePopover,
		onOpenPopover,
	}
}